<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import TradingFooter from '@/components/TradingBlock/TradingFooter.vue'
import { __ } from '@/utils/utils'
import RedirectButton from '@/components/RedirectButton/RedirectButton.vue'

defineProps({ data: Object })

const route = useRoute()
const lang = computed(() => route.params.lang || '')
</script>
<template>
  <div class="flex flex-col lg:flex-row">
    <div
      class="flex flex-col lg:justify-start items-center lg:items-start w-full lg:max-w-[346px] mt-10 lg:ml-10"
    >
      <div>
        <img loading="lazy" :src="data?.logo" :alt="data?.logo_alt" />
      </div>
      <div
        class="w-full mt-5 text-base px-[10px] md:px-[0px] lg:w-[311px] lg:h-[180px] -tracking-tightest"
      >
        {{ data?.description }}
      </div>
      <div class="flex justify-center w-full lg:hidden mt-5 lg:mt-0">
        <img loading="lazy" :src="data?.main_image_mobile" :alt="data?.main_image.alt" />
      </div>
      <div class="lg:mt-5 mt-0 w-full md:px-0 px-[10px] md:max-w-[311px]">
        <RedirectButton
          :href="data?.action_button_link"
          :text="data?.action_button_text"
          type="primary"
        />
        <div class="flex justify-center md:justify-between gap-2.5 lg:gap-0">
          <button type="button">
            <a :href="data?.google_play_link" target="_blank">
              <picture>
                <source media="(max-width: 600px)" :srcset="data?.google_play_icon_mobile" />
                <source media="(min-width: 601px)" :srcset="data?.google_play_icon" />
                <img loading="lazy" :src="data?.google_play_icon" />
              </picture>
            </a>
          </button>
          <button type="button">
            <a :href="data?.app_store_link" target="_blank">
              <picture>
                <source media="(max-width: 600px)" :srcset="data?.app_store_icon_mobile" />
                <source media="(min-width: 601px)" :srcset="data?.app_store_icon" />
                <img loading="lazy" :src="data?.app_store_icon" />
              </picture>
            </a>
          </button>
        </div>
      </div>
    </div>
    <div class="items-center justify-center hidden mt-12 lg:block min-h-[596px]">
      <img loading="lazy" :src="data?.main_image" :alt="data?.main_image.alt" />
    </div>
  </div>
  <TradingFooter
    :titleOne="data?.footer_column_one_title"
    :contentOne="data?.footer_column_one_content"
    :titleTwo="data?.footer_column_two_title"
    :contentTwo="data?.footer_column_two_content"
    :titleThree="data?.footer_column_three_title"
    :contentThree="data?.footer_column_three_content"
    :titleFour="data?.footer_column_four_title"
    :contentFour="data?.footer_column_four_content"
    :footerIconLink="data?.footer_icon"
    :footerIconAlt="data?.footer_icon_alt"
    class="lg:mb-20"
  ></TradingFooter>
</template>
